(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bluedot-recently-viewed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bluedot-recently-viewed')) {
 customElements.define('bluedot-recently-viewed', class extends HTMLElement {
  connectedCallback() {
   if(this.dataset.ready)return;this.dataset.ready='true';
   try {
    const key='bluedot_recent_products_v1';
    let previous=JSON.parse(localStorage.getItem(key)||'[]');
    if(!Array.isArray(previous))previous=[];
    previous=previous.filter(p=>p&&typeof p.handle==='string'&&typeof p.title==='string'&&typeof p.url==='string'&&p.url.startsWith('/products/')&&typeof p.image==='string'&&Number.isFinite(p.price));
    const current=this.querySelector('script');const product=current?JSON.parse(current.textContent):null;
    const list=previous.filter(p=>p.handle!==product?.handle).slice(0,Number(this.dataset.limit)||7);
    const grid=this.querySelector('.bd-recent-grid');
    list.forEach(p=>{
     const a=document.createElement('a');a.href=p.url;
     const image=document.createElement('img');image.src=p.image;image.alt=p.title;image.loading='lazy';image.width=500;image.height=500;
     const title=document.createElement('span');title.textContent=p.title;
     const price=document.createElement('span');price.textContent=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(p.price/100);
     a.append(image,title,price);grid.append(a);
    });
    if(list.length)this.hidden=false;
    if(product)localStorage.setItem(key,JSON.stringify([product,...previous.filter(p=>p.handle!==product.handle)].slice(0,10)));
   }catch(e){this.hidden=true;}
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
